import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литературное чтение. 2-3 класс.",
        subject: "Предупреждение трудностей формирования у младших школьников текстовой деятельности при изучении произведений эпоса.",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Предупреждение трудностей формирования у младших школьников текстовой деятельности при изучении произведений эпоса.",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Рожкова Марина Викторовна",
                grade: "к.пед.н.",
                subGrade: "",
                imageSrc: "./images/author_lit.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'><p>Анализ трудностей при изучении учебных предметов показывает, что типичные ошибки при выполнении диагностических заданий связаны с недостаточным развитием смыслового навыка чтения при работе с текстами разных жанров и стилей. </p>" +
                                "<p>Материал кейса не только раскрывает важность предупреждения указанных трудностей, но и демонстрирует комплексную работу по формированию смыслового чтения на примере работы с рассказом на уроках литературного чтения. </p>" +
                                "<p>Раскрытие методических особенностей работы с рассказом, начиная со 2 класса, позволит педагогу приобрести практические навыки организации работы по восприятию и интерпретации прозаических текстов. </p></div>"
                        },
                    ]
                },
                {
                    type: "table",
                    title: "Класс",
                    text: "2-3"
                },
                {
                    type: "table",
                    title: "Тема",
                    text: "Предупреждение трудностей формирования у младших школьников текстовой деятельности при изучении произведений эпоса (на примере работы с рассказом)."
                },
                {
                    type: "table",
                    title: "Цель кейса",
                    text: "Представить совокупность эффективных приёмов, обеспечивающих предупреждение трудностей формирования текстовой деятельности при изучении произведений эпоса (на примере работы с рассказом)."
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для педагога)",
                    unorderedList: [
                        "Совершенствовать профессиональные компетенции педагога в освоении и применении методов и приёмов, позволяющих предупреждать трудности формирования у младших школьников текстовой деятельности при изучении произведений эпоса (на примере работы с рассказом);",
                        "Обратить внимание педагога на проблему формирования смыслового чтения как коммуникативного универсального учебного действия;",
                        "Совершенствовать рефлексивную деятельность педагога: способность оценивать собственную педагогическую позицию."
                    ]
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для обучающихся)",
                    children: [
                        {
                            type: "table",
                            listLabel: "Личностные:",
                            unorderedList: [
                                "проявлять готовность выражать своё отношение в текстовой деятельности при работе с произведениями эпоса (на примере работы с рассказом);",
                                "осуществлять оценку поведения и поступков героев художественных произведений;",
                                "понимать образность языка художественных произведений и значение выразительных средств, создающих художественный образ."
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Метапредметные:",
                            unorderedList: [
                                "использовать смысловое чтение для решения различных учебных задач;",
                                "устанавливать причинно-следственные связи в сюжете художественного текста;",
                                "соблюдать логику текста при составлении плана его пересказа;",
                                "строить речевое высказывание в соответствии с поставленной задачей."
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Предметные:",
                            unorderedList: [
                                "осуществлять смысловое чтение рассказа;",
                                "понимать жанровую принадлежность произведения;",
                                "характеризовать (кратко) героя, особенности повествования;",
                                "анализировать текст рассказа: определять тему, главную мысль произведения;",
                                "участвовать в обсуждении прочитанного произведения;",
                                "формулировать устно простые выводы, подтверждать свой ответ примерами из текста."
                            ]
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/lit1.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/litdist1/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/lit2.mp4"
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                 {link: "https://fgosreestr.ru", title: "Реестр примерных основных общеобразовательных программ"},
                 {link: "https://edsoo.ru", title: "   Единое содержание общего образования"}
            ],
            literatures: [
                "Виноградова Н. Ф. Методическое сопровождение обновлённого Федерального государственного образовательного стандарта начального общего образования // Начальное образование. 2022. № 1 (108)",
                "Кузнецова М. И., Романова В. Ю., Хомякова И. С. Дидактическое сопровождение процесса обучения в начальной школе: формирование коммуникативных универсальных учебных действий. Методическое пособие. Москва, 2018",
                "Виноградова Н. Ф. Литературное чтение. Реализация требований ФГОС начального общего образования: методическое пособие для учителя / под ред. Н.Ф. Виноградовой. Москва: ФГБНУ «Институт стратегии развития образования РАО», 2022",
                "Об утверждении федеральной образовательной программы начального общего образования. Утверждена приказом Министерства просвещения Российской Федерации 16 ноября 2022 г., № 992, [Электронный ресурс].",
                "Рожкова М.В. Урок литературного чтения в первом классе: что важно учесть в соответствии с обновлённым стандартом // Начальное образование, №4 (111), 2022",
                "Универсальные учебные действия как планируемый результат в начальной школе. Книга для учителя / под ред. Н. Ф. Виноградовой. Москва, 2016",
                "Федеральный государственный образовательный стандарт начального общего образования. Утверждён приказом Министерства просвещения Российской Федерации 31 мая 2021 г., № 286, [Электронный ресурс]. ",
                "Н. Ф. Виноградова, Е. Э. Кочурова, М. И. Кузнецова [и др.]. Функциональная грамотность младшего школьника: книга для учителя / под ред. Н. Ф. Виноградовой. Москва, 2018"
            ],
            filesToDownload: [
                // {
                //     link: "./files/plan.docx",
                //     fileName: "Сценарный план"
                // },
            ]
        }
    ],
};
